<mat-icon [ngClass]="getClass()" (click)="openZCValidationPopup()" title="Zoning Code Validation Result">{{getIconType()}}</mat-icon>
